import { EventEmiterService } from './../../services/event-emiter.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { LocalStorageKeys, SearchTenantRequest, Tenant, Consorcio, SearchConsorcioRequest, MenuFuncion } from '../../../../../src/app/shared/model';
import { TenantService, ConsorcioService, MenuFuncionService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit {
  public menu: any[];
  public user: any;
  searchTermFormControl = new FormControl();
  public menuFuncion: MenuFuncion[];
  formGroup: FormGroup;
  formGroupSearch: FormGroup;

  public tenantList: Tenant[];
  isTenantSearching: boolean = false;
  public consorcioList: Consorcio[];
  isConsorcioSearching: boolean = false;

  isMenuSearching: boolean = false;
  public searchResults: MenuFuncion[] = [];
  public searchTerm: string = '';
  expandedParents: Set<number> = new Set<number>();

  @Output() reloadView: EventEmitter<any> = new EventEmitter();
  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    public consorcioService: ConsorcioService,
    public menuFuncionService: MenuFuncionService,
    public tenantService: TenantService,
    private eventEmitterService: EventEmiterService
  ) {
  }

  ngOnInit(): void {
    this.buildForm();

    this.menu = this.sharedFunctions.getLoggedUserMenus();
    this.user = this.sharedFunctions.getLoggedUser();

    this.getUserTenants();
  }

//!  búsqueda de menús

  matchesSearchTerm(item: MenuFuncion): boolean {
    const searchTerm = this.searchTerm?.toLowerCase();
    const itemName = item?.Nombre?.toLowerCase();
    const itemChildrenName = item.MenuHijos?.some(hijo => hijo?.Nombre?.toLowerCase()?.includes(searchTerm));

    return (itemName?.includes(searchTerm) || itemChildrenName);
  }

  matchesSearchTermChildren(subItem: MenuFuncion): boolean {
    const searchTerm = this.searchTerm?.toLowerCase();
    const itemName = subItem?.Nombre?.toLowerCase();

    return (itemName?.includes(searchTerm)) ?? false;
  }

  onSearchTermChange(value: string) {
    this.searchTerm = value;
    this.searchResults = this.menuFuncion?.filter(item => this.matchesSearchTerm(item));

    if (this.searchResults != null && this.searchResults.length > 0) {
      this.searchResults.forEach(result => {
        this.expandParentItems(result);
      });
    }
  }

  expandParentItems(item: MenuFuncion) {
    if (item != null && item.MenuPadreId) {
      const parentItem = this.menuFuncion?.find(parent => parent.Id === item.MenuPadreId);
      if (parentItem) {
        this.expandedParents.add(parentItem.Id);
        this.expandParentItems(parentItem);
      }
    }
  }

  clearSearchTerm() {
    this.searchTerm = '';
  }

  isParentExpanded(parentItem: any): boolean {
    return this.expandedParents.has(parentItem.Id);
  }

//! fin búsqueda de menús

  reloadData() {
    this.getUserTenants();
  }

  buildForm() {
    var initialTenant : number | null = null;
    try {
      var v1 = Number(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId));
      if (v1 != null && v1 > 0)
        initialTenant = v1;
    } catch (ex) {
      console.error(ex);
    }

    var initialConsorcioId = 0;
    try {
      var v2 = Number(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId));
      if (v2 != null && !Number.isNaN(v2))
        initialConsorcioId = v2;
    } catch (ex) {
      console.error(ex);
    }

    this.formGroup = this.formBuilder.group({
      'Tenant': [initialTenant],
      'Consorcio': [initialConsorcioId],
    });
  }

  getUserTenants() {
    if (this.user != null && this.user.Id != null && this.user.Id > 0) {
      var r = new SearchTenantRequest(null, null, true, "Nombre", null, null, this.user?.Id, true);
      this.isTenantSearching = true;

      this.tenantService.search(r).subscribe(data => {
        this.isTenantSearching = false;
        if (data != null) {
          this.tenantList = data?.result;

          var tenantId = this.formGroup.get("Tenant")?.value;
          if (this.tenantList != null && this.tenantList.length > 0) {
            if (tenantId == null || tenantId <= 0) {
              this.formGroup.get("Tenant")?.setValue(this.tenantList[0]?.Id);
              tenantId = this.tenantList[0]?.Id;
            }
          }
          else {
            this.formGroup.get("Tenant")?.setValue(null);
            tenantId = null;
          }

          if (tenantId != null && tenantId > 0) {
            this.onTenantSelect(false);
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.isTenantSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  getTenantConsorcios() {
    var v = this.formGroup.get("Tenant")?.value;

    if (v != null && v > 0) {
      var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, Number(v), true);
      this.isConsorcioSearching = true;

      this.consorcioService.search(r).subscribe(data => {
        this.isConsorcioSearching = false;
        if (data != null) {
          this.consorcioList = data?.result;

          if (this.consorcioList != null && this.consorcioList.length > 0) {
            if (this.consorcioList.length > 1) {

            }
            else {
              this.formGroup.get("Consorcio")?.setValue(this.consorcioList[0].Id);
              // this.onConsorcioSelect();
            }
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.isConsorcioSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  onTenantSelect(reloadView: boolean) {
    this.sharedFunctions.setLocalStorageValue(LocalStorageKeys.TenantId, this.formGroup.get("Tenant")?.value);

    if (reloadView) {
      this.formGroup.get("Consorcio")?.setValue(0);
      this.onConsorcioSelect();
    }

    this.getTenantConsorcios();
    this.getMenuTenant();
    this.getTenantDiccionario(this.formGroup.get("Tenant")?.value);

    // this.router.navigate(['/home']);
    if (reloadView)
      window.location.reload();
  }

  recargaVistas() {
    this.eventEmitterService.triggerReloadView();
  }

  getTenantDiccionario(tenantId: number) {
    this.tenantService.getTenantDiccionarioSimplificadoById(tenantId).subscribe(data => {
      if (data != null && data.Result != null) {
        this.sharedFunctions.setLocalStorageValue(LocalStorageKeys.NamesToReplace, JSON.stringify(data.Result));
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  getDiccionarioTraduccion(key: string){
    return this.sharedFunctions.getNombreMenuTenant(key);
  }

  getMenuTenant() {
    var v = this.formGroup.get("Tenant")?.value;
    // console.log("getMenuTenant >> ", v);
    if (v != null && v > 0) {
      this.isMenuSearching = true;

      this.menuFuncionService.getByTenant().subscribe(data => {
        this.isMenuSearching = false;
        if (data != null && data.Success) {
          this.sharedFunctions.setLocalStorageValue(LocalStorageKeys.Menu, JSON.stringify(data.Result));
          this.menu = data.Result;
          // console.log(this.menu);
        }
      },
      (err: HttpErrorResponse) => {
        this.isMenuSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  onConsorcioSelect() {
    this.sharedFunctions.setLocalStorageValue(LocalStorageKeys.ConsorcioId, this.formGroup.get("Consorcio")?.value);

    this.recargaVistas();
    this.clearSearchTerm();
  }

  showConsorcios() {
    var selectedTenant = this.formGroup.get("Tenant")?.value;
    return (selectedTenant != null && selectedTenant > 0 && this.consorcioList != null && this.consorcioList.length > 1);
  }

  validateMenu(menuItem: any) {
    return (menuItem != null && menuItem.Visible);
  }

  hasMenuChildren(menuItem: any) {
    if(menuItem != null && menuItem.MenuHijos != null)
    {
      for(var i in menuItem.MenuHijos)
      {
        if(this.validateMenu(menuItem.MenuHijos[i])) {
          return true;
        }
      }
    }
    return false;
  }

  showMenuIcon(item: any) {
    return (item != null && item.Icono != null && item.Icono.toString().length > 0);
  }
}
